import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import { RegionMemberActions } from '../actions/region-member.actions';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {RegionService} from '../../../services/region.service';
import * as featureActions from '../../index';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';


@Injectable()
export class RegionMemberEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private regionService = inject(RegionService);

  constructor() {}

  ReadRegionMember$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMemberActionTypes.ReadCompanyMember),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // debugger;
      const params = {
        otp: user.otp,
        region_id: action.payload
      };
      return this.regionService.ReadCompanyMember(params).pipe(
        map((res: any) => {
          // debugger;
          if (res) {
            return new featureActions.ReadCompanyMemberSuccess(res);
          } else {
            return new featureActions.ReadCompanyMemberFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.ReadCompanyMemberFail());
        })
      );
    })
  ));
  UpdateRegionMember$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMemberActionTypes.UpdateCompanyMember),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // debugger;
      const params = {
        otp: user.otp,
        mail: action.payload.mail,
        region_id: action.payload.region_id
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateRegionMember
      };
      return this.regionService.UpdateCompanyMember(params).pipe(
        switchMap((res: any) => {
          // debugger;
          if (res.result) {
            // GetAllAccounts() 是為了 UpdateCompanyMember 後更新 account 資料
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true }), new featureActions.GetAllAccounts()];
          } else {
            return [new featureActions.UpdateCompanyMemberFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError((error) => {
            return [new featureActions.UpdateCompanyMemberFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Error' })];
        })
      );
    })
  ));
  ActivateRegionMember$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMemberActionTypes.ActivateCompanyMember),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // debugger;
      const params = {
        otp: user.otp,
        region_id: action.payload.region_id
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ActivateRegionMember
      };
      return this.regionService.ActivateCompanyMember(params).pipe(
        switchMap((res: any) => {
          // debugger;
          if (res.result) {
            return [new featureActions.GetRegions(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true })];
          } else {
            return [new featureActions.ActivateCompanyMemberFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError((error) => {
            return [new featureActions.ActivateCompanyMemberFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Error' })];
        })
      );
    })
  ));
  CheckRegionMember$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMemberActionTypes.CheckCompanyMember),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = { ...action.payload,otp: user.otp, };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.CheckRegionMember
      };
      return this.regionService.CheckCompanyMember(params).pipe(
        switchMap((res: any) => {
          // debugger;
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: res.msg.body })];
          } else {
            return [new featureActions.CheckCompanyMemberFail(),
              new featureActions.UpdateInfoFailAction({ ...updateRes, msg: res.msg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError((error) => {
            return [new featureActions.CheckCompanyMemberFail(),
              new featureActions.UpdateInfoFailAction(updateRes)];
        })
      );
    })
  ));
}
